// menu.js
const hamburger = document.querySelector('.hamburger');
const menu = document.querySelector('.menu');

hamburger.addEventListener('click', () => {
  hamburger.classList.toggle('active');
  menu.classList.toggle('active');
  document.body.classList.toggle('no-scroll'); // al abrir
});


//header scroll 
const header = document.getElementById("main");
const hero = document.getElementById("hero");

window.addEventListener("scroll", () => {
  const heroBottom = hero.offsetTop + hero.offsetHeight;
  if (window.scrollY > heroBottom) {
    header.classList.add("scrolled");
  } else {
    header.classList.remove("scrolled");
  }
});

// --- LIGHTBOX / GALLERY OVERLAY ---
(function(){
  const gallery = document.querySelector('.home-gallery-container');
  if (!gallery) return;

  function openLightbox(imgSrc, alt=''){
    if (document.querySelector('.lightbox-overlay')) return; // already open

    const overlay = document.createElement('div');
    overlay.className = 'lightbox-overlay';
    overlay.innerHTML = `
      <div class="lightbox-inner" role="dialog" aria-modal="true">
        <button class="lightbox-close" aria-label="Close">&times;</button>
        <img class="lightbox-img" src="${imgSrc}" alt="${alt}" />
      </div>
    `;
    document.body.appendChild(overlay);
    document.body.classList.add('no-scroll');

    // allow CSS transition to run
    requestAnimationFrame(() => overlay.classList.add('open'));

    const closeBtn = overlay.querySelector('.lightbox-close');
    function close(){
      overlay.classList.remove('open');
      document.body.classList.remove('no-scroll');
      document.removeEventListener('keydown', onKey);
      overlay.addEventListener('transitionend', () => overlay.remove(), { once: true });
    }
    function onKey(e){
      if (e.key === 'Escape') close();
    }

    closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', (e) => { if (e.target === overlay) close(); });
    document.addEventListener('keydown', onKey);

    closeBtn.focus();
  }

  gallery.addEventListener('click', (e) => {
    const clicked = e.target.closest('picture, img');
    if (!clicked) return;
    const img = clicked.tagName === 'IMG' ? clicked : clicked.querySelector('img');
    if (!img) return;
    const src = img.currentSrc || img.src;
    openLightbox(src, img.alt || '');
  });
})();


